/* unplugin-vue-components disabled */import script from "./Sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./Sidebar.vue?vue&type=style&index=0&id=5a3dae30&lang=sass&scoped=true"
import "./Sidebar.vue?vue&type=style&index=1&id=5a3dae30&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a3dae30"]])

export default __exports__